/* eslint semi: 1, react/prop-types:1 */
/* global $ */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import request from 'superagent';
import swal from 'sweetalert';
import {
    updateContactFirstName,
    updateContactLastName,
    updateContactEmail,
    updateContactMessage,
    resetContactData
} from '../actions/app-actions';

class Contact extends React.Component {

    componentDidMount() {
        $('input')[0].focus();
    }

    render() {
        const {
            firstName,
            lastName,
            email,
            message,
            firstNameChanged,
            lastNameChanged,
            emailChanged,
            messageChanged,
            formSubmitted
        } = this.props;

        return (
            <div>
                <div className="page-header">
                    <h1>Contact</h1>
                </div>
                <form onSubmit={e => formSubmitted(e, firstName, lastName, email, message)}>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>First Name:</label>
                                <input type="text" className="form-control" required={true} placeholder="Enter first name" value={firstName} onChange={firstNameChanged} />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Last Name:</label>
                                <input type="text" className="form-control" required={true} placeholder="Enter last name" value={lastName} onChange={lastNameChanged} />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Email:</label>
                                <input type="email" className="form-control" required={true} placeholder="Enter email addres" value={email} onChange={emailChanged} />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label>Message:</label>
                                <textarea className="form-control" rows="5" style={{resize: 'vertical'}} required={true} value={message} onChange={messageChanged} />
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <button type="submit" className="btn btn-primary"><i className="fa fa-paper-plane-o" aria-hidden="true"></i> Submit</button>
                    </div>
                </form>
            </div>
        );
    }

}

Contact.propTypes = {
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    message: PropTypes.string,
    firstNameChanged: PropTypes.func,
    lastNameChanged: PropTypes.func,
    emailChanged: PropTypes.func,
    messageChanged: PropTypes.func,
    formSubmitted: PropTypes.func
};

const ContactContainer = connect(
    state => {
        const { appState } = state;
        return {
            firstName: appState.contactFirstName,
            lastName: appState.contactLastName,
            email: appState.contactEmail,
            message: appState.contactMessage
        };
    },
    dispatch => {
        return {
            firstNameChanged(e) {
                e.preventDefault();
                dispatch(updateContactFirstName(e.target.value));
            },
            lastNameChanged(e) {
                e.preventDefault();
                dispatch(updateContactLastName(e.target.value));
            },
            emailChanged(e) {
                e.preventDefault();
                dispatch(updateContactEmail(e.target.value));
            },
            messageChanged(e) {
                e.preventDefault();
                dispatch(updateContactMessage(e.target.value));
            },
            formSubmitted(e, firstName, lastName, email, message) {
                e.preventDefault();

                request
                    .post('/contact-form-submit')
                    .send({
                        firstName,
                        lastName,
                        email,
                        message
                    })
                    .end(err => {
                        if(err) {
                            console.error(err);
                            swal('Oops!', 'There was a problem submitting the form. Please try again later.', 'error');
                        } else {
                            swal('Success!', 'Form successfully submitted.', 'success');
                            dispatch(resetContactData());
                        }
                    });
            }
        };
    }
)(Contact);

export default ContactContainer;



/** WEBPACK FOOTER **
 ** ./src/components/contact.js
 **/